import { useMutation, useQueryClient } from '@tanstack/react-query';
import { loaders } from './shop.loaders';
import { shopKeys } from './shop.queries';

export const useAddToSelection = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.addToSelection, {
    onSuccess: () => {
      return queryClient.invalidateQueries(shopKeys.all);
    },
  });
};

export const useRemoveFromSelection = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.removeFromSelection, {
    onSuccess: () => {
      return queryClient.invalidateQueries(shopKeys.all);
    },
  });
};

export const useBulkAddToSelection = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.bulkAddToSelection, {
    onSuccess: () => {
      return queryClient.invalidateQueries(shopKeys.all);
    },
  });
};

export const useBulkRemoveFromSelection = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.bulkRemoveFromSelection, {
    onSuccess: () => {
      return queryClient.invalidateQueries(shopKeys.all);
    },
  });
};
